import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hero-dosimetria',
  templateUrl: './hero-dosimetria.component.html',
  styleUrls: ['./hero-dosimetria.component.scss']
})
export class HeroDosimetriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
